
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/egypt/forms/download-hotel-chain-development-report",
      function () {
        return require("private-next-pages/egypt/forms/download-hotel-chain-development-report.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/egypt/forms/download-hotel-chain-development-report"])
      });
    }
  